import { ResolvedSegment } from './type';

export const segmentRef = (segment: ResolvedSegment): string => segment.presetKey ?? segment.id ?? '';

export const isAddressableSegment = (segment: ResolvedSegment): boolean => Boolean(segmentRef(segment));
